<mat-form-field fxFlex="100" [formGroup]="group" [appearance]="formType">
    <mat-label>{{field.label}}</mat-label>
    <input [attr.guide]="'price-inp-1-1' + '__' + sanitizeUrl(url)" matInput [formControlName]="field.name" [placeholder]="field.label" [type]="field.inputType"/>
    <ng-container *ngFor="let validation of field['dynamicFormLabelValidator'];" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
    </ng-container>
</mat-form-field>